var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mt-1",attrs:{"variant":"relief-danger"},on:{"click":function($event){$event.stopPropagation();return _vm.hidden()}}},[_vm._v(" Mostrar/Ocultar ["+_vm._s(_vm.selected.length)+"] ")])}
var staticRenderFns = []

export { render, staticRenderFns }